export { default as hasOwn } from 'core-js-pure/actual/object/has-own'

export const filterObj = <K extends string, V>(
  obj: Record<K, V>,
  pred: ([key, value]: [K, V]) => boolean,
) => {
  const entries = Object.entries(obj) as [K, NonNullable<V>][]
  return Object.fromEntries(entries.filter(pred)) as Partial<Record<K, V>>
}

export const removeNullEntries = <K extends string, V>(obj: Record<K, V>) =>
  filterObj(obj, ([_, v]) => v !== null) as Partial<Record<K, NonNullable<V>>>
